import Color from '../Color.mjs'
import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.DARK_GREEN,
    mapProp: 'map',
    name: '中间件实例',
    ownerIdProp: 'middlewareId',
    ownerTextProp: 'middlewareName',
    ownerType: 'MID',
    textProp: 'middlewareInsName',
    type: 'MIDINS',
}

